import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import c from 'classnames';
import { CommentContext } from '../../CommentContext';
import ActionsMenu from '../ActionsMenu';
import BylineBlock from '../BylineBlock';
import ContentBox from '../ContentBox';
import ContentTextRenderer from '../ContentTextRenderer';
import s from './ReadContentBlock.scss';
/**
 * Contains the main content of a comment's read view: comment text, byline, and action menu.
 */ const ReadContentBlock = (_param)=>{
    var { children, className, canPostComment } = _param, rest = _object_without_properties(_param, [
        "children",
        "className",
        "canPostComment"
    ]);
    const { comment, setCanShowActionMenu } = useContext(CommentContext);
    return /*#__PURE__*/ React.createElement(ContentBox, _object_spread({
        className: c(s['root'], className),
        onMouseEnter: ()=>setCanShowActionMenu(true),
        onMouseLeave: ()=>setCanShowActionMenu(false)
    }, rest), /*#__PURE__*/ React.createElement(BylineBlock, {
        className: s['author']
    }), !!comment.textContent && /*#__PURE__*/ React.createElement(ContentTextRenderer, {
        comment: comment
    }), /*#__PURE__*/ React.createElement(ActionsMenu, {
        className: s['actions-menu'],
        canPostComment: canPostComment
    }));
};
ReadContentBlock.displayName = 'ReadContentBlock';
export default ReadContentBlock;

//# sourceMappingURL=ReadContentBlock.js.map